require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./categories-تسجيل-الصوت.json") })
        }
      }, "path---categories-تسجيل-الصوت");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---categories-تسجيل-الصوت!./.cache/json/categories-تسجيل-الصوت.json
// module id = 537
// module chunks = 231608221292675